import React from 'react'
import PageWrapper from '../layouts/Index'
import PageTitle from './PageTitle'
import { useSelector } from 'react-redux';

const OxygenRecheckEligibilty = ({handleRefresh}) => {
  const isLoading = useSelector((state) => state.oxygenRetail?.otpLoading);

  return (
    <PageWrapper>
        <PageTitle title="Recheck Eligibility" />
        <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body text-center">
              <div className="col-md-12 justify-content-xl-center">
                <div className="row justify-content-center">
                  <div className="col-md-6 d-flex justify-content-center">
                    <div className="terms">
                        <h4> <b>Eligibility Check in Progress: Click Refresh Eligibility for Updates</b></h4>
                        <button
                            type="button"
                            className="btn btn-primary text-white mr-3 my-3 p-2"
                            onClick={handleRefresh}
                        >
                           {isLoading ? "Please wait..." : "Refresh Eligibility"} 
                        </button>
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
    </PageWrapper>
  )
}

export default OxygenRecheckEligibilty